import * as cnames from 'classnames'
import * as React from 'react'

import { IItemCard } from '../interface'

import ItemCardSmallPreview from '../itemCardSmallPreview'
import LockupAudioPreview from '../lockupAudioPreview'
import LockupCurrentAudioTrackInfo from '../lockupCurrentAudioTrackInfo'
import LockupActionPanel from '../lockupListActionPanel'
import LockupTitleAuthor from '../lockupTitleAuthor'

import * as styles from './itemCardCurrentAudioContent.module.css'

const ItemCardCurrentAudioContent = (props: IItemCard) => {
  const isGrid = props.viewType === 'grid'

  return (
    <div className={styles.root}>
      <div
        className={cnames(styles.trackInfo, {
          [styles.trackInfoGrid]: isGrid
        })}
      >
        <LockupAudioPreview {...props} />

        <LockupCurrentAudioTrackInfo {...props} />
      </div>
      <div
        className={cnames(styles.itemInfo, {
          [styles.itemInfoGrid]: isGrid
        })}
      >
        <span
          className={cnames(styles.title, {
            [styles.titleGrid]: isGrid
          })}
        >
          <span className={styles.icon}>
            <ItemCardSmallPreview {...props} />
          </span>
          <LockupTitleAuthor inline={!isGrid} {...props} />
        </span>
        <span className={cnames(styles.icons, { [styles.gridIcons]: isGrid })}>
          <LockupActionPanel {...props} />
        </span>
      </div>
    </div>
  )
}
export default ItemCardCurrentAudioContent
